/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react';

function countdownFormatter(segundos) {
	const minutos = Math.floor(segundos / 60);
	const segundosRestantes = segundos % 60;
	return (
		minutos.toString().padStart(2, '0') +
		':' +
		segundosRestantes.toString().padStart(2, '0')
	);
}

export default function useRenewToken(expiration, secondsBeforeExpiration, isLogin) {
	const [isExpired, setIsExpired] = useState(false);
	const [renew, setRenew] = useState(false);
	const [openModal, setOpenModal] = useState(false);
	const [leftSeconds, setLeftSeconds] = useState(null);
	const clickEventRef = useRef();

	useEffect(() => {
		if (expiration) {
			const now = new Date().getTime();
			const dateRangeToClick = new Date(expiration);
			const before = dateRangeToClick.setSeconds(
				dateRangeToClick.getSeconds() - secondsBeforeExpiration
			);
			if (now < before || now > new Date(expiration).getTime()) {
				setOpenModal(false);
			}
		}
	}, [expiration]);

	useEffect(() => {
		if (expiration) {
			const mount = setInterval(() => {
				if (isLogin && renew === false) {
					if (Date.now() > new Date(expiration).getTime()) {
						setIsExpired(true);
						setOpenModal(false);
						setLeftSeconds(null);
						return;
					}
					const now = new Date().getTime();
					const dateRangeToClick = new Date(expiration);
					const before = dateRangeToClick.setSeconds(
						dateRangeToClick.getSeconds() - secondsBeforeExpiration
					);
					// console.log(new Date(before));
					// console.log(new Date(expiration));
					//Verifica si la fecha y hora actual esta despues de los segundos
					// y antes de la expiracion
					if (now >= before && now <= new Date(expiration).getTime()) {
						//Saca los segundos restantes para la expiracion
						setLeftSeconds(
							countdownFormatter(
								Math.floor(
									(new Date(expiration).getTime() - Date.now()) / 1000
								)
							)
						);
						//Abre el modal
						if (!openModal) {
							setOpenModal(true);
						}
						//Se genera el evento y se guarda en el useRef
						if (!clickEventRef.current) {
							clickEventRef.current = (e) => {
								if (!renew) {
									setRenew(true);
									setOpenModal(false);
								}
							};
							window.addEventListener('click', clickEventRef?.current, {
								once: true,
							});
							window.addEventListener('keypress', clickEventRef?.current, {
								once: true,
							});
							window.addEventListener('scroll', clickEventRef?.current, {
								once: true,
							});
							window.addEventListener('mousemove', clickEventRef?.current, {
								once: true,
							});
						}
					} else {
						//Si ya existe el evento en el useRef se quita el evento para evitar multiples clicks y
						// multiples llamadas a la api
						if (clickEventRef.current) {
							window.removeEventListener('click', clickEventRef.current);
							window.removeEventListener('keypress', clickEventRef.current);
							window.removeEventListener('scroll', clickEventRef.current);
							window.removeEventListener(
								'mousemove',
								clickEventRef.current
							);
							clickEventRef.current = undefined;
						}
					}
				}
			}, 1000);
			return () => {
				clearInterval(mount);
			};
		}
	}, [isLogin, expiration, renew, openModal]);

	return { isExpired, renew, setRenew, openModal, leftSeconds };
}
